import { PersonalAnalysticsService } from './../../../data/repository/analytics-repository/personal-analystics.service';
import { UserDataService } from './../../../data/repository/user-repository/user-data.service';
import { AddQuikFoodLog } from './../../../core/model/input/food-log-input-model';
import { CalendarShared } from './../shared/calendar-shared';
import { ResponseDayExerciseLogs } from './../../../core/model/api-response/plans-response-model';
import { ExerciseService } from './../../../data/repository/plan-repository/exercise.service';
import { AddActivityLogParams } from './../../../core/model/object/exercise-model';
import { Component, OnInit, Input } from '@angular/core';
import { BottomsheetShared } from '../shared/bottomsheet-shared';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { FoodFactsModel } from 'src/app/core/model/object/diet-food-model';
import { DietSearchMealModel } from 'src/app/core/model/object/diet-model';
import { Weightlog } from 'src/app/core/model/api-response/weight-log-response-model';
import { DateHelper } from 'src/app/utils/date-helper';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { LoadingShared } from '../shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { PlanShared } from '../shared/plan-shared';
import { TextHelper } from 'src/app/utils/text-helper';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { FoodLogService } from 'src/app/data/repository/plan-repository/food-log.service';
import { ExerciseItem } from 'src/app/core/model/api-response/plans-response-model';
import { CookingStoryService } from '../../../data/repository/cooking-story/cooking-story.service';
import { CookingStoryApiService } from '../../../data/repository/cooking-story/cooking-story-api.service';
import { WebengageService } from 'src/app/data/repository/analytics-repository/webengage.service';

@Component({
  selector: 'app-bottomsheet',
  templateUrl: './bottomsheet.component.html',
  styleUrls: ['./bottomsheet.component.scss'],
})
export class BottomsheetComponent implements OnInit {
  @Input() type: string;
  @Input() meal?: string;
  @Input() data?: { url: string; title: string; share: string };
  exerciseLogClicked: boolean = false;
  customeExerciseClicked: boolean = false;
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  date: Date;
  weightlog: Weightlog;
  weight: string;
  isActivated = true;
  title: string;
  foodFact: FoodFactsModel;
  foodFactNames = [];
  foodFactAmounts = [];
  foodFactUnits = [];
  package: DietSearchMealModel;
  mealFoodAmounts = [];
  mealSecondUnitTitle: string;

  quikCTitle: string = null;
  quikCalorie: number = null;
  quikActive: boolean = false;

  center: boolean = false;
  startDay = 1;
  elementTop = 36;
  startDays: string[] = [
    'امروز',
    'فردا',
    'پس‌فردا',
    '۳ روز بعد',
    '۴ روز بعد',
    '۵ روز بعد',
    '۶ روز بعد',
  ];
  days = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'];
  activity: string;
  calorie: number;
  timeExercise: number;
  exerciseCalorie: number = 0;
  exrecise: ExerciseItem;
  editExercise: ResponseDayExerciseLogs;
  Cdate: number;

  reportMessage: string;

  constructor(
    public bottomsheetShared: BottomsheetShared,
    private weightLogService: WeightLogService,
    private dateHelper: DateHelper,
    private planService: PlanService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private planShared: PlanShared,
    private textHelper: TextHelper,
    private diaryAnalytics: DiaryAnalyticsService,
    private calendarShared: CalendarShared,
    private foodLogService: FoodLogService,
    private userService: UserDataService,
    private personalAnalysticsService: PersonalAnalysticsService,
    private exerciseService: ExerciseService,
    private cookingstoryApi: CookingStoryApiService,
    private webengage: WebengageService
  ) {
    this.Cdate = this.bottomsheetShared.CDate;
  }

  ngOnInit() {
    if (this.type === 'weightLog') {
      this.title = 'وزن خود را وارد کنید';
      this.weightlog = this.bottomsheetShared.selectedWeightlog;
      this.weight = this.weightlog.weight.toString();
      this.date = this.bottomsheetShared.selectedDate;
    } else if (this.type === 'foodFact') {
      this.title = 'جدول ارزش غذایی ';
      this.mealSecondUnitTitle = this.bottomsheetShared.selectedFoodSecondUnit;
      this.prepareFoodFacts();
    } else if (this.type === 'fastcalorie') {
      this.title = 'افزودن سریع کالری';
    } else if (this.type === 'mealDetail') {
      // console.log(this.bottomsheetShared.selectedPackage)
      this.package = this.bottomsheetShared.selectedPackage;
      this.package.amounts.forEach((food, index) => {
        let unit = '';
        this.package.foods[index].foodId.foodUnitRatioArray.forEach((ratio) => {
          if (
            ratio.unitId._id ===
            this.package.foods[index].foodId.primaryFoodUnit
          ) {
            unit = ratio.unitId.name;
          }
        });
        this.mealFoodAmounts[index] = food.amount + ' ' + unit;
      });
    } else if (this.type === 'startDay') {
      this.title = 'روز شروع برنامه غذایی را انتخاب کنید';
      const day = new Date();
      day.setDate(day.getDate() + 2);
      for (let d = 0; d < 5; d++) {
        this.startDays[d + 2] = this.days[day.getDay()];
        day.setDate(day.getDate() + 1);
      }
      this.startDay = this.bottomsheetShared.startDay;
      this.elementTop -= (this.startDay - 1) * 50;
      setTimeout(() => {
        document.getElementById('bottomsheet-start-day-holder').style.top =
          this.elementTop.toString() + 'px';
      }, 50);
    } else if (this.type === 'cutome-exercise') {
      this.title = 'افزودن فعالیت';
      this.center = true;
    } else if (this.type === 'exercise') {
      this.title = this.bottomsheetShared.exerciseTitle;
      this.exrecise = this.bottomsheetShared.exerciseItem;
    } else if (
      this.type === 'edit-exercise' ||
      this.type === 'edit-custome-exercise'
    ) {
      this.editExercise = this.bottomsheetShared.ExerciseLogDay;
      this.title = this.editExercise.name;
      this.exerciseCalorie = parseInt(this.editExercise.calorie.toFixed(0));
      if (this.type === 'edit-exercise') {
        this.getExerciseMet(this.title);
        this.timeExercise = this.editExercise.duration;
      }
    }
    document
      .getElementById('bottomsheet')
      .addEventListener('click', (e) => e.stopPropagation());
    setTimeout(() => {
      document.getElementById('bottomsheet').style.transform =
        'translate(0, 0)';
    }, 10);
  }
  report() {
    this.type = 'recipe-report';
  }
  share() {
    const newVariable = window.navigator;
    if (newVariable && newVariable.share) {
      window.navigator.share({
        url: this.data.share,
      });
    } else {
      // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.bottomsheetShared.shareLink;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snackBarService.showSnackBar('لینک پست کپی شد');
    }
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.closeBottomsheet();
    }
  }

  swipeStartDay(action: string = this.SWIPE_ACTION.DOWN) {
    // next
    if (action === this.SWIPE_ACTION.DOWN) {
      this.previousDay();
    }

    // previous
    if (action === this.SWIPE_ACTION.UP) {
      this.nextDay();
    }
  }

  nextDay() {
    if (this.startDay < 6) {
      this.startDay++;
      this.elementTop -= 50;
      document.getElementById('bottomsheet-start-day-holder').style.top =
        this.elementTop.toString() + 'px';
    }
  }

  previousDay() {
    if (this.startDay > 0) {
      this.startDay--;
      this.elementTop += 50;
      document.getElementById('bottomsheet-start-day-holder').style.top =
        this.elementTop.toString() + 'px';
    }
  }

  closeBottomsheet() {
    document.getElementById('bottomsheet').style.transform =
      'translate(0, 100%)';
    setTimeout(() => {
      this.bottomsheetShared.closeBottomsheet();
    }, 300);
  }

  closeAndUpdateBottomsheet() {
    document.getElementById('bottomsheet').style.transform =
      'translate(0, 100%)';
    setTimeout(() => {
      this.bottomsheetShared.closeAndUpdateBottomsheet();
    }, 300);
  }
  async exerciseCalculator() {
    let weight = await this.weightLogService.getSelectedDayWeight(
      new Date(new Date().setHours(0, 0, 0, 1))
    );

    this.exerciseCalorie =
      (this.timeExercise *
        (this.bottomsheetShared.met *
          3.5 *
          weight.getData().getWeightLog().weight)) /
      200;
    this.exerciseCalorie = parseInt(this.exerciseCalorie.toFixed(0));
  }
  async customeExercise() {
    if (
      this.calorie >= 1 &&
      this.activity.length >= 1 &&
      !this.customeExerciseClicked
    ) {
      this.customeExerciseClicked = true;
      const user = await this.userService.getUser();
      const data = new AddActivityLogParams(
        user._id,
        this.Cdate,
        this.calorie,
        null,
        this.activity,
        null
      );
      this.exerciseService.addActivityLog([data]).then((res) => {
        if (res.isSuccess()) {
          this.diaryAnalytics.analyticDiarySimpleActivityAdd();
          this.webengage.exerciseLogAdded('quick');
          this.snackBarService.showSnackBar('فعالیت با موفقیت اضافه شد');
          setTimeout(() => {
            this.closeBottomsheet();
          }, 100);
        } else {
          this.customeExerciseClicked = false;
        }
      });
    }
  }
  getExerciseMet(name: string) {
    this.exerciseService.searchExercise(name).then((res) => {
      if (res.isSuccess()) {
        this.bottomsheetShared.met = res
          .getData()
          .getExerciseSearch().exercises[0].met;
      }
    });
  }
  async Exercise() {
    if (this.timeExercise > 0 && !this.exerciseLogClicked) {
      this.exerciseLogClicked = true;
      const user = await this.userService.getUser();
      const data = new AddActivityLogParams(
        user._id,
        this.Cdate,
        parseInt(this.exerciseCalorie.toFixed(0)),
        this.timeExercise,
        this.exrecise.name,
        this.exrecise._id
      );

      this.exerciseService.addActivityLog([data]).then((res) => {
        if (res.isSuccess()) {
          if (this.bottomsheetShared.SearchHistoryExercise) {
            this.diaryAnalytics.analyticDiaryAddRecentSearchActivity();
          } else {
            this.diaryAnalytics.analyticDiaryAddSearchActivity();

            this.snackBarService.showSnackBar('فعالیت با موفقیت اضافه شد');
            setTimeout(() => {
              this.closeBottomsheet();
            }, 100);
          }
        } else {
          this.exerciseLogClicked = false;
        }
      });
    }
  }
  updateExercise() {
    this.exerciseService
      .updateExercise(
        this.editExercise._id,
        parseInt(this.exerciseCalorie.toFixed(0)),
        this.timeExercise
      )
      .then((res) => {
        if (res.isSuccess()) {
          this.diaryAnalytics.analyticDiaryActivityEdit();
          this.webengage.exerciseLogAdded('exercise');

          this.snackBarService.showSnackBar('فعالیت با موفقیت ویرایش شد');
          setTimeout(() => {
            this.closeBottomsheet();
          }, 100);
        }
      });
  }
  removeExercise() {
    this.exerciseService.deleteExercise([this.editExercise._id]).then((res) => {
      if (res.isSuccess()) {
        this.diaryAnalytics.analyticDiaryActivityDelete();
        this.snackBarService.showSnackBar('فعالیت با موفقیت حذف شد');
        setTimeout(() => {
          this.closeBottomsheet();
        }, 100);
      }
    });
  }
  submit() {
    this.clickAnimation();
    if (this.type === 'weightLog') {
      let today = new Date(this.date.getTime());
      today = new Date(today.setHours(0, 0, 0, 1));
      this.loadingShared.showLoading();
      if (
        this.dateHelper.isSameDay(today, new Date(this.weightlog.date)) &&
        this.weightlog._id !== '-'
      ) {
        this.weightLogService
          .updateWeight(
            parseFloat(this.textHelper.replacePersian(this.weight)),
            this.weightlog._id
          )
          .then((res) => {
            if (res.isSuccess()) {
              this.diaryAnalytics.analyticDiaryWeightChanged();
              setTimeout(() => {
                this.closeAndUpdateBottomsheet();
              }, 150);
            } else {
              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
            this.loadingShared.hideLoading();
          });
      } else {
        this.weightLogService
          .addWeight(
            today.getTime(),
            parseFloat(this.textHelper.replacePersian(this.weight))
          )
          .then((res) => {
            if (res.isSuccess()) {
              this.diaryAnalytics.analyticDiaryWeightChanged();
              setTimeout(() => {
                this.closeAndUpdateBottomsheet();
              }, 150);
            } else {
              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
            this.loadingShared.hideLoading();
          });
      }
    } else if (this.type === 'mealDetail') {
      this.loadingShared.showLoading();
      const dietId = this.bottomsheetShared.selectedDietId;
      const mealPackage = this.bottomsheetShared.selectedPackage;
      const day = this.bottomsheetShared.selectedDay;
      const meal = this.bottomsheetShared.selectedMeal;
      this.planService
        .changePackage(dietId, mealPackage, day, meal)
        .then((res) => {
          if (res.isSuccess()) {
            this.diaryAnalytics.analyticDiaryPackageChanged(meal);
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else if (this.type === 'startDay') {
      const dietId = this.bottomsheetShared.selectedDietId;
      this.loadingShared.showLoading();
      this.planService.changeStartDay(dietId, this.startDay).then((res) => {
        if (res.isSuccess()) {
          this.diaryAnalytics.analyticDiaryStartDayChanged(this.startDay);
          this.closeBottomsheet();
          this.planShared.refreshDiet();
        } else {
          if (res.getData().getMessage() && res.getData().getMessage() !== '') {
            this.snackBarService.showSnackBar(res.getData().getMessage());
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.closeBottomsheet();
        }
        this.loadingShared.hideLoading();
      });
    }
  }

  activateButton() {
    if (
      parseFloat(this.textHelper.replacePersian(this.weight)) > 30 &&
      parseFloat(this.textHelper.replacePersian(this.weight)) < 300
    ) {
      this.isActivated = true;
    } else {
      this.isActivated = false;
    }
  }
  activeQuikAdd() {
    if (
      this.quikCTitle &&
      this.quikCalorie &&
      parseInt(this.textHelper.replacePersian(this.quikCalorie.toString())) >= 0
    ) {
      this.quikActive = true;
    } else {
      this.quikActive = false;
    }
  }
  async addQuikFood() {
    if (this.quikActive) {
      const user = await this.userService.getUser();
      const foodlogList: AddQuikFoodLog[] = [
        new AddQuikFoodLog(
          this.calendarShared.selectedDate.getTime(),
          0,
          parseInt(this.textHelper.replacePersian(this.quikCalorie.toString())),
          this.quikCTitle,
          this.meal,
          [],
          user._id
        ),
      ];
      this.foodLogService.addQuikFood(foodlogList).then((res) => {
        if (res.isSuccess()) {
          this.snackBarService.showSnackBar(res.getData().getMessage());
          this.closeBottomsheet();
          this.personalAnalysticsService.analyticAddSimpleFood();
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.closeBottomsheet();
        }
      });
    }
  }
  sendReport() {
    if (this.reportMessage && this.reportMessage.length > 0) {
      this.cookingstoryApi
        .cookingStorysendRepost(this.reportMessage, this.data.url)
        .then((res) => {
          if (res.isSuccess()) {
            this.closeBottomsheet();
            this.snackBarService.showSnackBar('پیغام شما با موفقیت ارسال شد');
          }
        });
    }
  }
  clickAnimation() {
    const element = document.getElementById('bottomsheet-submit');
    element.style.width = '185px';
    // element.style.right = '28px';
    element.style.height = '32px';
    element.style.bottom = '28px';
    setTimeout(() => {
      element.style.width = '191px';
      // element.style.right = '24px';
      element.style.height = '40px';
      element.style.bottom = '24px';
    }, 100);
  }

  prepareFoodFacts() {
    this.foodFactNames = this.bottomsheetShared.selectedFoodFactsNames;
    this.foodFactAmounts = this.bottomsheetShared.selectedFoodFactsAmounts;
    this.foodFactUnits = this.bottomsheetShared.selectedFoodFactsUnits;
  }
}
